import { connect } from 'react-redux';
import { editDeviation } from '../../../redux/deviations/actionCreators';
const mapDispatchToProps = {
    onClick: editDeviation
};
export default connect(null, mapDispatchToProps);
